import {
  createArrayValidator,
  createObjectValidator,
  validateNumber
} from "../../../../packages/validator/validator.js";
import { QueryItem, validateQueryItem } from "../query/QueryItem.js";

export type ZeroRateTaxedAmount = {
  /**
   * Services (income) offered to non-Estonian EU companies.
   */
  services: number;
  /**
   * Items associated with the services offered.
   */
  servicesItems: QueryItem[];
};

export const validateZeroRateTaxedAmount = createObjectValidator<ZeroRateTaxedAmount>("ZeroRateTaxedAmount", {
  services: validateNumber,
  servicesItems: createArrayValidator(validateQueryItem)
});
